export default __webpack_public_path__ + "static/media/usa-flag.1f5b6c86.svg";